import React from "react";
import "../styles/notFound.css";

const NotFound = () => {
  return (
    <>
      <div className="notFound">
        <h1 className="num">404</h1>
        <h2 className="message">Not Found</h2>
      </div>
    </>
  );
};

export default NotFound;
